module.exports = __webpack_public_path__ + "media/images/slide-4-643f663defa93d63f78fe4b79ca242c6.png";